import { ArrowRightIcon } from '@heroicons/react/24/outline';
import { GQLPlatformBlocksFragment } from '@theprintbar/graphql';
import { cn } from '@theprintbar/shared';
import { ButtonSize, OutlineLinkButton, RichText, TransparentLinkButton } from '@theprintbar/ui';

interface PlatformBlocksProps {
	content: GQLPlatformBlocksFragment;
}

export const PlatformBlocks = ({ content }: PlatformBlocksProps) => {
	return !!content.platformBlocks.structure ? (
		<div className="mx-4 lg:mx-8">
			<div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
				{content.platformBlocks.structure.map((item, index) =>
					item ? (
						<div className={cn('relative flex flex-col justify-items-stretch')} key={index}>
							<div className="relative rounded-lg h-40 w-full overflow-hidden mb-8 border border-blue">
								{item.image && (
									<img
										loading="lazy"
										src={item.image.image.url}
										alt={item.image.altText || 'icon image'}
										className="absolute top-0 right-0"
									/>
								)}
							</div>
							<div className="mb-8">
								<h4 className="mb-3 uppercase text-base">{item.title}</h4>
								<RichText className="text-sm" {...item.text} />
							</div>
							<div className="flex gap-2 mt-auto justify-self-end">
								{!!item.buttonLink && (
									<OutlineLinkButton
										size={ButtonSize.XS}
										className="uppercase font-bold"
										to={item.buttonLink}
										icon={ArrowRightIcon}
									>
										{item?.buttonText}
									</OutlineLinkButton>
								)}
								{!!item.buttonSecondaryLink && (
									<TransparentLinkButton
										size={ButtonSize.XS}
										className="uppercase font-bold"
										to={item.buttonSecondaryLink}
										icon={ArrowRightIcon}
									>
										{item.buttonSecondaryText}
									</TransparentLinkButton>
								)}
							</div>
						</div>
					) : null,
				)}
			</div>
		</div>
	) : null;
};
